import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { User as UserIcon, CreditCard, Landmark, ShieldCheck, Bell, Users, FileCheck } from "lucide-react";
import ProfileTab from "@/components/settings/ProfileTab";
import FundingTab from "@/components/settings/FundingTab";
import PayoutTab from "@/components/settings/PayoutTab";
import SecurityTab from "@/components/settings/SecurityTab";
import NotificationsTab from "@/components/settings/NotificationsTab";
import TeamTab from "@/components/settings/TeamTab";
import ComplianceTab from "@/components/settings/ComplianceTab";

const TABS = [
  { id: "profile", label: "Profile", icon: UserIcon },
  { id: "funding", label: "Payment methods", icon: CreditCard },
  { id: "payout", label: "Payout methods", icon: Landmark },
  { id: "security", label: "Security", icon: ShieldCheck },
  { id: "notifications", label: "Notifications", icon: Bell },
  { id: "team", label: "Team", icon: Users },
  { id: "compliance", label: "Tax & compliance", icon: FileCheck },
];

const Settings = () => {
  const { user, refresh } = useAuth();
  const refreshUser = refresh;
  const [active, setActive] = useState("profile");

  if (!user) return null;

  return (
    <div className="space-y-6" data-testid="settings-page">
      <div>
        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold">Settings</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mt-1">Account & payouts</h1>
        <p className="mt-2 text-sm text-muted-foreground">One account for paying and getting paid. Manage your profile, methods, security and team.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-6 items-start">
        <nav className="bg-card border border-border rounded-xl p-2 lg:sticky lg:top-4" aria-label="Settings sections">
          <ul className="flex lg:flex-col gap-1 overflow-x-auto">
            {TABS.map((t) => {
              const Icon = t.icon;
              const is = active === t.id;
              return (
                <li key={t.id}>
                  <button
                    type="button"
                    onClick={() => setActive(t.id)}
                    className={`lg:w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${is ? "bg-primary text-primary-foreground" : "hover:bg-secondary/60 text-foreground"}`}
                    data-testid={`settings-tab-${t.id}`}
                  >
                    <Icon className="w-4 h-4" /> {t.label}
                  </button>
                </li>
              );
            })}
          </ul>
        </nav>
        <div className="space-y-6 min-w-0">
          {active === "profile" && <ProfileTab user={user} refreshUser={refreshUser} />}
          {active === "funding" && <FundingTab user={user} refreshUser={refreshUser} />}
          {active === "payout" && <PayoutTab user={user} refreshUser={refreshUser} />}
          {active === "security" && <SecurityTab user={user} refreshUser={refreshUser} />}
          {active === "notifications" && <NotificationsTab user={user} refreshUser={refreshUser} />}
          {active === "team" && <TeamTab user={user} refreshUser={refreshUser} />}
          {active === "compliance" && <ComplianceTab user={user} refreshUser={refreshUser} />}
        </div>
      </div>
    </div>
  );
};

export default Settings;
